<div #form="ngForm" ngForm [ngClass]="styles.formGroupBg">

	<div [ngClass]="styles.externalPresentersRow" flex-justify="end">
		<button type="button" vbBtnPrimary [disabled]="!addEnabled" (click)="add()">
			{{'Add' | translate}}
		</button>
	</div>

	@for (speaker of webcast.brandingSettings.speakerProfiles; let index = $index; track $index) {
		@if (speaker.isEdit) {
			<div #presenterGroup="ngModelGroup" [ngModelGroup]="'speaker' + index" [ngClass]="styles.externalPresentersFormGroup">

				<div class="form-group row">
					<label #uiLabel class="control-label col-sm-2" [for]="'speakerProfileAvatar' + index">{{'Image' | translate}}</label>
					<div class="col-sm-10">
						<image-selector [id]="'speakerProfileAvatar' + index" name="brandingBannerImage" [imageComponentMetadata]="{ showDeleteButton: true }" [(ngModel)]="speaker.edits.avatarImage">
						</image-selector>
					</div>
				</div>
				<vb-ui-form-group [controlClass]="styles.inlineRequired">
					<label #uiLabel [for]="'speakerProfileName' + index">{{'Name' | translate}}</label>
					<input type="text" [id]="'speakerProfileName' + index" name="name" class="form-control" required #editName="ngModel" [(ngModel)]="speaker.edits.name" uiControl [vbMaxLength]="100" trim="blur"/>

					@if(editName.touched && editName.invalid) {
						<div role="alert" vbUiErrorMessage uiValidation class="mb-2">
							@if (editName.errors.required) {
								{{ 'ThisFieldIsRequired' | translate }}
							}
							@else if (editName.errors.vbMaxLength) {
								{{ 'MaximumAllowedCharacters' | translate : { '0': 100} }}
							}
						</div>
					}
				</vb-ui-form-group>

				<vb-ui-form-group>
					<label #uiLabel [for]="'speakerProfileRole' + index">{{'Admin_Role' | translate}}</label>

					<input type="text" [id]="'speakerProfileRole' + index" #editRole="ngModel" name="role" class="form-control" [(ngModel)]="speaker.edits.role" uiControl [vbMaxLength]="100" trim="blur"/>

					@if(editRole.touched && editRole.invalid) {
						<div role="alert" vbUiErrorMessage uiValidation class="mb-2">
								{{ 'MaximumAllowedCharacters' | translate : { '0': 100} }}
						</div>
					}
				</vb-ui-form-group>

				<vb-ui-form-group>
					<label #uiLabel [for]="'speakerProfileDesc' + index">{{'Description' | translate}}</label>

					<textarea [id]="'speakerProfileDesc' + index" name="description" class="form-control" [(ngModel)]="speaker.edits.description" #editSpeakerDescription="ngModel" rows="10" uiControl [vbMaxLength]="250" trim="blur">
					</textarea>
					@if(editSpeakerDescription.touched && editSpeakerDescription.invalid) {
						<div role="alert" vbUiErrorMessage uiValidation class="mb-2">
							{{ 'MaximumAllowedCharacters' | translate : { '0': 250} }}
						</div>
					}
				</vb-ui-form-group>

				<button type="button" vbBtnPrimary [attr.aria-label]="'Apply' | translate" [tooltip]="'Apply' | translate" container="body" delay="500" [disabled]="presenterGroup.invalid" (click)="applyEdits(speaker)">
					<span class="glyphicons ok_2"></span>
				</button>
				<button type="button" vbBtnSecondary [attr.aria-label]="'Cancel' | translate" [tooltip]="'Cancel' | translate" container="body" delay="500" (click)="cancelEdit(speaker, index)">
					<span class="glyphicons remove_2"></span>
				</button>
			</div>
		}
		@else {
			<div [ngClass]="styles.externalPresentersRow">
				<vb-profile-picture [profileUrl]="speaker.data.avatarImage?.url" [size]="'large'">
				</vb-profile-picture>
				<span flex="fill">
					<header>{{speaker.data.name}} {{ speaker.data.role ? '(' + speaker.data.role + ')' : '' }}</header>
					{{speaker.data.description}}
				</span>
				<button type="button" [attr.aria-label]="'Edit' | translate" [tooltip]="'Edit' | translate" container="body" delay="500" (click)="startEdit(speaker)">
					<span class="glyphicons pencil"></span>
				</button>

				<button type="button" [attr.aria-label]="'Remove' | translate" [tooltip]="'Remove' | translate" container="body" delay="500" (click)="remove(index)">
					<span class="glyphicons bin"></span>
				</button>
			</div>
		}
	}

</div>
